export interface DownloadWindowWebComponentSchema {
  path: string;
  streamId: string;
  maxFilesSize: number;
}

export const START_VALIDATE_DOWNLOAD_PATH = 'start-validate-download-path';
export const VALIDATE_DOWNLOAD_PATH = 'validate-download-path';

export const VALIDATE_ARCHIVE_PASSWORD = 'validate-archive-password';
export const VALIDATE_REPEAT_PASSWORD = 'validate-repeat-password';

export const VALIDATE_PASSWORD_TOGGLE = 'validate-password-toggle';
